import { getStatusToken } from '../../design-system/status';
import type { OperationalStatus } from '../../design-system/status';
import { useI18n } from '../../i18n';
import type { TranslationKey } from '../../i18n';

interface StatusBadgeProps {
  status: OperationalStatus;
  className?: string;
}

export function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const token = getStatusToken(status);
  const { t } = useI18n();
  const labelKey: Record<OperationalStatus, TranslationKey> = {
    ONLINE: 'status.online',
    OFFLINE: 'status.offline',
    GOOD: 'status.good',
    HALF: 'status.half',
    DEFECT: 'status.defect',
    RECARGA: 'status.recarga',
    APPROVED: 'status.approved',
    FAILED: 'status.failed',
    RETEST: 'status.retest',
    RECHARGE: 'status.recharge',
    IDLE: 'status.idle',
    ANALYZING: 'status.analyzing',
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.08em] ${token.badgeClass} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${token.dotClass}`} />
      {t(labelKey[status])}
    </span>
  );
}
